import React from 'react';
class FallbackErrorBoundary extends React.Component {
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error
        };
    }
    render() {
        if (this.state.hasError) {
            return this.props.fallback(this.state.error, this.clearError);
        }
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false,
            error: null
        };
        this.clearError = ()=>this.setState({
                hasError: false
            });
    }
}
export { FallbackErrorBoundary as default };
